import React from 'react';
import PropTypes from 'prop-types';

export const ProgressBar = ({
  percentValue, label, useLabelOnTheRight,
}) => {
  const style = { width: `${percentValue}%` };
  let rightLabel = null;
  let progressbarLabel = null;
  if (useLabelOnTheRight) {
    rightLabel = <div className="right-label">{label}</div>;
  } else {
    progressbarLabel = label;
  }

  return (
    <div className={useLabelOnTheRight ? 'progress-bar-with-right-label' : ''}>
      <div className="progress">
        <div className="progress-bar" role="progressbar" aria-valuenow={percentValue} aria-valuemin="0" aria-valuemax="100" style={style} >
          {progressbarLabel}
        </div>
      </div>
      {rightLabel}
    </div>
  );
};

ProgressBar.propTypes = {
  percentValue: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  useLabelOnTheRight: PropTypes.bool,
};

ProgressBar.defaultProps = {
  useLabelOnTheRight: false,
};
